<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            title="搜索条件"
            :width="1000"
            footer-hide>
            <search-card :form="mainTable.searchForm"
                :table-load-event="getSaleStatList"
                :table-search="mainTable.tableSearch" ref="searchCard" />
        </Modal>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span style="width: 100px;" class="title">销售统计分析</span>
                        <span style="margin-left:5px;width: 70px;">统计时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            :clearable="false"
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width:200px"
                            @on-change="onDateChange"></DatePicker>
						<span style="margin-left:10px;width:70px">会员类别:</span>
                        <RadioGroup v-model="userType"
                            style="margin-left:10px;width:180px;"
                            @on-change="onUserTypeChange">
                            <Radio label="F"> <span>外部会员</span></Radio>
                            <Radio label="E"> <span>内部会员</span></Radio>
                        </RadioGroup>
						<span style="margin-left:5px;font-size:12px;width: 60px;">是否0价单:</span>
						<RadioGroup v-model="totalOrderCost"
						    style="margin-left:5px;width:100px;"
						    @on-change="onTotalOrderCostChange">
						    <Radio label="0"> <span>否</span></Radio>
						    <Radio label="1"> <span>是</span></Radio>
						</RadioGroup>
                        <RadioGroup v-model="groupBy"
                            style="margin-left:10px;width:240px;"
                            type="button"
                            size="small"
                            @on-change="onGroupByChange">
                            <Radio label="seedFarm"> <span>苗场</span> </Radio>
                            <Radio label="manager"> <span>经理</span> </Radio>
							<Radio label="station"> <span>转运站</span> </Radio>
                            <Radio label="product"> <span>商品</span> </Radio>
                            <Radio label="member"> <span>会员</span> </Radio>
                            <Radio label="mainCate"> <span>大类</span> </Radio>
                            <Radio label="subCate"> <span>小类</span> </Radio>
							<Radio label="province"> <span>省</span> </Radio>
							<Radio label="city"> <span>市</span> </Radio>
							<Radio label="dist"> <span>区</span> </Radio>
                        </RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            @click="onExport()">导出</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.statColumns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :extHeight="-50"
                    :pageSizeOptions="mainTable.sizeConfig"
                    :table-load-event="getSaleStatList"/>
                </Col>
            </Row>
			
        </Card>

    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat,getNumberThousandString,formatWithDecimalFixed } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getPreSaleStat, getSalesStatisticalAnalysis, getCombineSaleStatDetail } from '@/api/modules/sale-management/sale-stat';
import { getRegionCascade } from '@/api/modules/system-management/region-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';

export default {
    name: 'salesStatisticalAnalysis',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        let columnWidth=100;
        let tableSearch=search.getSearchParams();
        tableSearch.limit.conditions.pageLength=50;

        return {
			userType:'F',
			totalOrderCost:'',
            groupBy: 'seedFarm',
            selectDates: [],
            allRegions: [],
            columnWidth:100,
            mainTable: {
                statColumns: [  {
                                title: '统计项',
                                width:200,
                                key: 'groupName',
                                align: 'center',
                                fixed: 'left'
                            },
                    {
                        title: '本期销量对比',
                        align: 'center',
                 
                        children: [
                            {
                                title: '本期',
                                key: 'thisIssueQuantity',
                                width: columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {}, getNumberThousandString(params.row.thisIssueQuantity, 0, 0));
                                }
                            },
                            {
                                title: '同期',
                                key: 'thisIssueQuantityLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span',  getNumberThousandString(params.row.thisIssueQuantityLast, 0,0 ));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'thisIssueQuantityDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.thisIssueQuantityDifference>0?'#666':'red'                                   
                                            }
                                        }, getNumberThousandString(params.row.thisIssueQuantityDifference, 0,0));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'thisIssueQuantityDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.thisIssueQuantityDifferencePercent>0?'#666':'red'                                   
                                            }
                                        },  getNumberThousandString(params.row.thisIssueQuantityDifferencePercent,0, 2));
                                }
                            }
                        ]
                    },
                    {
                        title: '本年累计销量对比',
                        align: 'center',
                        width:1500,
                        children: [
                            {
                                title: '本年累计',
                                key: 'thisYearQuantity',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {}, getNumberThousandString(params.row.thisYearQuantity, 0,0));
                                }
                            },
                            {
                                title: '同期',
                                key: 'thisYearQuantityLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return   h('span', {}, getNumberThousandString(params.row.thisYearQuantityLast, 0, 0));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'thisYearQuantityDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span',  {
                                            style: {
                                                color: params.row.thisYearQuantityDifference>0?'#666':'red'                                   
                                            }
                                        },  getNumberThousandString(params.row.thisYearQuantityDifference, 0, 0));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'thisYearQuantityDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.thisYearQuantityDifferencePercent>0?'#666':'red'                                   
                                            }
                                        }, getNumberThousandString(params.row.thisYearQuantityDifferencePercent, 0, 2));
                                }
                            }
                        ]
                    },
                    {
                        title: '滚动周年销量对比',
                        align: 'center',
                        children: [
                            {
                                title: '滚动周年',
                                key: 'rollQuantity',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return    h('span', {}, getNumberThousandString(params.row.rollQuantity, 0, 0));
                                }
                            },
                            {
                                title: '同期',
                                key: 'rollQuantityLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {}, getNumberThousandString(params.row.rollQuantityLast, 0, 0));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'rollQuantityDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.rollQuantityDifference>0?'#666':'red'                                   
                                            }
                                        }, getNumberThousandString(params.row.rollQuantityDifference, 0, 0));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'rollQuantityDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {
                                            style: {
                                                color: params.row.rollQuantityDifferencePercent>0?'#666':'red'                                   
                                            }
                                        }, getNumberThousandString(params.row.rollQuantityDifferencePercent, 0, 2));
                                }
                            }
                        ]
                    },
                    {
                        title: '本期有效金额对比',
                        align: 'center',
                        children: [
                            {
                                title: '本期',
                                key: 'thisIssueSaleMony',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {}, formatWithDecimalFixed(params.row.thisIssueSaleMony, 2));
                                }
                            },
                            {
                                title: '同期',
                                key: 'thisIssueSaleMonyLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {}, formatWithDecimalFixed(params.row.thisIssueSaleMonyLast, 2));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'thisIssueSaleMonyDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {
                                            style: {
                                                color: params.row.thisIssueSaleMonyDifference>0?'#666':'red'                                   
                                            }
                                        }, formatWithDecimalFixed(params.row.thisIssueSaleMonyDifference, 2));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'thisIssueSaleMonyDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span',  {
                                            style: {
                                                color: params.row.thisIssueSaleMonyDifferencePercent>0?'#666':'red'                                   
                                            }
                                        }, formatWithDecimalFixed(params.row.thisIssueSaleMonyDifferencePercent, 2));
                                }
                            }
                        ]
                    },
                    {
                        title: '本年累计有效金额对比',
                        align: 'center',
                        children: [
                            {
                                title: '本期',
                                key: 'thisYearSaleMony',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {}, formatWithDecimalFixed(params.row.thisYearSaleMony, 2));
                                }
                            },
                            {
                                title: '同期',
                                key: 'thisYearSaleMonyLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return   h('span', {}, formatWithDecimalFixed(params.row.thisYearSaleMonyLast, 2));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'thisYearSaleMonyDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.thisYearSaleMonyDifference>0?'#666':'red'                                   
                                            }
                                        }, formatWithDecimalFixed(params.row.thisYearSaleMonyDifference, 2));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'thisYearSaleMonyDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {
                                            style: {
                                                color: params.row.thisYearSaleMonyDifferencePercent>0?'#666':'red'                                   
                                            }
                                        }, formatWithDecimalFixed(params.row.thisYearSaleMonyDifferencePercent, 2));
                                }
                            }
                        ]
                    },
                    {
                        title: '滚动周年有效金额对比',
                        align: 'center',
                        children: [
                            {
                                title: '本期',
                                key: 'rollSaleMony',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {}, formatWithDecimalFixed(params.row.rollSaleMony, 2));
                                }
                            },
                            {
                                title: '同期',
                                key: 'rollSaleMonyLast',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return  h('span', {}, formatWithDecimalFixed(params.row.rollSaleMonyLast, 2));
                                }
                            },
                            {
                                title: '增减额',
                                key: 'rollSaleMonyDifference',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', {
                                            style: {
                                                color: params.row.rollSaleMonyDifference>0?'#666':'red'                                   
                                            }
                                        },  formatWithDecimalFixed(params.row.rollSaleMonyDifference, 2));
                                }
                            },
                            {
                                title: '增减率(%)',
                                key: 'rollSaleMonyDifferencePercent',
                                width:columnWidth,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span',  {
                                            style: {
                                                color: params.row.rollSaleMonyDifferencePercent>0?'#666':'red'                                   
                                            }
                                        },   formatWithDecimalFixed(params.row.rollSaleMonyDifferencePercent, 2));
                                }
                            }
                        ]
                    },
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: tableSearch,
                sizeConfig:[50, 100, 200, '所有']
            }
        };
    },
    // props: {
    //     userType: { type: String, default: 'F' }
    // },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getAllRegionList();
        this.init();
    },
    methods: {
		
		reSetsearchForm(){
            let userPersonNameValue=this.getSearchFormValue('userPersonName');
            let seedFarmNameValue=this.getSearchFormValue('seedFarmName');
            let distributionStationNameValue=this.getSearchFormValue('distributionStationName');
            let userCustomerManagerNameValue=this.getSearchFormValue('userCustomerManagerName');
            let mainCategoryNameValue=this.getSearchFormValue('mainCategoryName');
            let subCategoryNameValue=this.getSearchFormValue('subCategoryName');
            let productNameValue=this.getSearchFormValue('productName');
        
            
			if(this.groupBy=="product"||this.groupBy=="mainCate"||this.groupBy=="subCate"){
				this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: userPersonNameValue, name: 'userPersonName', sql: 'like' },
                    { label: '苗场', type: 'Input', value:seedFarmNameValue, name: 'seedFarmName', sql: 'like' },
                    { label: '大类', type: 'Input', value: mainCategoryNameValue, name: 'mainCategoryName', sql: 'like' },
                    { label: '小类', type: 'Input', value: subCategoryNameValue, name: 'subCategoryName', sql: 'like' },
					{ label: '转运站', type: 'Input', value: distributionStationNameValue, name: 'distributionStationName', sql: 'like' },
                    { label: '客户经理', type: 'Input', value: userCustomerManagerNameValue, name: 'userCustomerManagerName', sql: 'like' },
                    { label: '商品信息', type: 'Input', value: productNameValue, name: 'productName', sql: 'like' }];
			}
			else{
				this.mainTable.searchForm=[{ label: '会员', type: 'Input', value: userPersonNameValue, name: 'userPersonName', sql: 'like' },
				    { label: '苗场', type: 'Input', value: seedFarmNameValue, name: 'seedFarmName', sql: 'like' },
					{ label: '转运站', type: 'Input', value: distributionStationNameValue, name: 'distributionStationName', sql: 'like' },
				    { label: '客户经理', type: 'Input', value:userCustomerManagerNameValue, name: 'userCustomerManagerName', sql: 'like' }];
			}
		},
        getSearchFormValue(name){
           let search= this.mainTable.searchForm.find(x=>x.name==name);
           if(!search){
              return '';
           }
           return search.value;
        },
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getSaleStatList();
        },
        onSaleChage(e) {
            this.getSaleStatList(true);
        },
        onUserTypeChange(e) {
            this.getSaleStatList();
        },
		onTotalOrderCostChange(e) {
		    this.getSaleStatList();
		},
        onGroupByChange(e) {
            debugger
			this.mainTable.tableSearch.filters.conditions=[];
            this.getSaleStatList();
        },
        onDateChange() {
            this.getSaleStatList();
        },
        getAllRegionList() {
            getRegionCascade().then(res => {
                if (res.code === 0) {
                    let find = this.mainTable.searchForm.find(item => item.name === 'memberDeliveryAddressDistUuid');
                    if (find) {
                        find.cascaderData = res.data.regionCascader;
                    }
                }
            });
        },
        onExport() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
			this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getSalesStatisticalAnalysis(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
                this.mainTable.loading = false;
            });
        },
        getSaleStatList(reset = false) {
           
			// this.reSetColumns();
			this.reSetsearchForm();   
            let pageStart= this.mainTable.tableSearch.limit.conditions.pageStart ;      

            search.globalSetFilterWithSearchForm(this.mainTable.tableSearch, search.filterForm(this.mainTable.searchForm));
            this.mainTable.tableSearch.limit.conditions.pageStart =pageStart;
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
			this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
 
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            this.mainTable.sarchCardShow=false;
            getSalesStatisticalAnalysis(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
         
                if (res.code === 0) {
                    this.mainTable.data = res.data.listCombine;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.count);
                    // let preSaleValueAll = 0;
                    // let preSaleCountAll = 0;
					// let totalReceiveCountAll = 0;
                    // let combinDepositAll = 0;
					// let saleDiscountValueAll = 0;
					// let refundTotalValAll = 0;
					// let saleRealValueAll = 0;
					// let commissionValueAll = 0;
                    // this.mainTable.data.forEach(e => {
                    //     preSaleValueAll += e.preSaleValue;
                    //     preSaleCountAll += e.preSaleCount;
					// 	totalReceiveCountAll += e.totalReceiveCount;
                    //     combinDepositAll += e.combinDeposit;
					// 	saleDiscountValueAll += e.saleDiscountValue;
					// 	refundTotalValAll += e.refundTotalVal;
					// 	saleRealValueAll += e.saleRealValue;
					// 	commissionValueAll +=e.commissionValue;
                    // });
                    // this.mainTable.data.push({
                    //     preSaleValue: numberToFixed(preSaleValueAll, 2),
                    //     preSaleCount: numberToFixed(preSaleCountAll, 2),
					// 	totalReceiveCount: numberToFixed(totalReceiveCountAll, 2),
                    //     combinDeposit: numberToFixed(combinDepositAll, 2),
					// 	saleDiscountValue: numberToFixed(saleDiscountValueAll, 2),
					// 	refundTotalVal: numberToFixed(refundTotalValAll, 2),
					// 	saleRealValue: numberToFixed(saleRealValueAll, 2),
					// 	commissionValue: numberToFixed(commissionValueAll, 2),
                    //     groupName: '合计',
                    //     action: -1
                    // });
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
	.div-header{
		display: flex;
		justify-content: flex-end;
	}
	.div-header .btn-font{
		font-size: 18px;
		line-height: 0 !important;
	}
	.global-tool-bar .left-bar{
		height: 60px !important;
	}
	.global-tool-bar .right-bar{
		height: 60px !important;
	}
	.global-tool-bar .left-bar .title{
		width:100px !important;
		margin: 0 15px 0 5px !important;
	}
	.ivu-radio-group-button.ivu-radio-group-small .ivu-radio-wrapper{
		padding:0px 5px !important;
	}
</style>
